import React, { useEffect } from "react";
import PropTypes from "prop-types";
import TitlePages from "../../layout/TitlePages";
import Breadcrumbs from "../../layout/Breadcrumbs";
import "./ParlamentoInfantil.css";

const TextParagraph = ({ children, strongText }) => (
  <p>
    {children}
    {strongText && <strong className="text-strong">{strongText}</strong>}
  </p>
);

const ParticipationStep = ({ step }) => <li>{step}</li>;

const SubParticipationStep = ({ substep, index }) => {
  const letter = String.fromCharCode(97 + index); // 'a', 'b', etc.
  return (
    <li className="civica-substep-item">
      <span className="civica-substep-letter">{letter})</span>
      <span className="civica-substep-text">{substep}</span>
    </li>
  );
};

export const ParlamentoInfantil = () => {
  useEffect(() => {
    document.title = `Parlamento Infantil`;
  }, []);
  const substeps = [
    "Cédula de inscripción",
    "Copia simple, fotografía o documento escaneado de acta de nacimiento",
    "Copia simple, fotografía o documento escaneado de constancia de estudios o boleta parcial de calificaciones;",
    "Nombre, clave escolar y número telefónico de la escuela, así como el nombre y número de teléfono del padre, madre o tutor.",
    "Carta de autorización de registro, firmada por el padre, madre o tutor",
    "Oficio del director en formato físico, fotografía o documento escaneado de la Institución Educativa de procedencia o representante del CONAFE, por medio del que se solicite la inscripción del niño o niña, en el que manifieste haber sido seleccionado bajo los lineamientos de la primera etapa (consultar etapas en la convocatoria vigente).",
    "Escrito de tres cuartillas como máximo en formato físico o documento escaneado, con algunos de los temas señalados en la convocatoria vigente.",
    "Copia simple, fotografía o documento escaneado de la credencial de la niña o niño participante."
  ];

  return (
    <>
      <Breadcrumbs
        path={[{ label: "Cultura Cívica" }, { label: "Parlamento Infantil" }]}
      />

      <div className="margin-bottom-2">
        <TitlePages title="Cultura Cívica" subTitle="Parlamento Infantil" />

        <div className="ContenidoCivica">
          <TextParagraph strongText=" edición anual del Parlamento Infantil.">
            Cada año el{" "}
            <strong className="text-strong">
              Instituto Tlaxcalteca de Elecciones
            </strong>{" "}
            colabora con aliados estratégicos como el Congreso del Estado, la Secretaría de Educación Pública del Estado de Tlaxcala y la Unidad de Servicios Educativos del Estado de Tlaxcala, la Coordinación Territorial en el Estado de Tlaxcala del Consejo Nacional de Fomento Educativo; la Comisión Estatal de Derechos Humanos, el Sistema Estatal para el Desarrollo Integral de la Familia, el Consejo Estatal de Población y el Sistema Estatal de Protección Integral de Niñas, Niños y Adolescentes para convocar a la niñez tlaxcalteca a participar en la
          </TextParagraph>

          <h3>¿Cómo participar?</h3>
          <ol className="civica-steps-list">
            <ParticipationStep step="Revisar la convocatoria que emita la Comisión Organizadora." />
            <ParticipationStep step="Cursar el quinto o sexto grado de primaria, o su equivalente en el Sistema CONAFE." />
            <ParticipationStep
              step="Las niñas y niños interesados en participar en las etapas de selección deberán presentar por escrito un tema con una extensión de hasta tres cuartillas, el cual deberán exponer oralmente en las diversas etapas de selección, teniendo para ello un tiempo entre tres y cinco minutos, lo cual realizarán sin apoyo de ningún documento o dispositivo digital (los temas se dispondrán en la convocatoria vigentes para la edición correspondiente)."
            />
            <ParticipationStep step="Cumplir con los siguientes requisitos:" />
          </ol>
          <ul className="civica-substeps-list">
            {substeps.map((substep, index) => (
              <SubParticipationStep key={index} index={index} substep={substep} />
            ))}
          </ul>

          <div className="civica-contacto">
            <h3>Datos de contacto:</h3>
            <p>
              Dirección de Organización Electoral, Capacitación y Educación Cívica
              <br /> Ex – Fábrica San Manuel S/N, Barrio Nuevo, C.P. 90640, San
              Miguel Contla, Santa Cruz Tlaxcala, Tlaxcala.
              <br />
              Correo electrónico:{" "}
              <a
                href="mailto:organizacionelectoral@itetlax.org.mx"
                className="civica-email-link"
              >
                organizacionelectoral@itetlax.org.mx
              </a>
              <br />
              Tel. 246 46 50340 ext. 105 y 106
            </p>
          </div>
        </div>
      </div>
    </>
  );
};

export default ParlamentoInfantil;

TextParagraph.propTypes = {
  children: PropTypes.node,
  strongText: PropTypes.string,
};

ParticipationStep.propTypes = {
  step: PropTypes.string.isRequired,
};

SubParticipationStep.propTypes = {
  substep: PropTypes.string.isRequired,
  index: PropTypes.number.isRequired,
};
